import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-wild',
  templateUrl: './wild.component.html',
  styleUrls: ['./wild.component.scss']
})
export class WildComponent implements OnInit {

  public wildMsg:string = 'User access denied !'
  constructor() { }

  ngOnInit() {
  }

}
